import { render, staticRenderFns } from "./Mantenimiento.vue?vue&type=template&id=66681bde&scoped=true"
import script from "./Mantenimiento.vue?vue&type=script&lang=js"
export * from "./Mantenimiento.vue?vue&type=script&lang=js"
import style0 from "./Mantenimiento.vue?vue&type=style&index=0&id=66681bde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66681bde",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VIcon,VImg,VRow})
